import {
  createContext,
  SetStateAction,
} from 'react';

export type Breadcrumb = {
  label?: string;
  translationKey?: string; // Added to support dynamic translation
  force?: boolean;
  path?: string;
  parentPath?: string;
  uniquePath?: string;
  index?: boolean;
};

export type BreadcrumbsContextType = {
  breadcrumbs: Breadcrumb[];
  setBreadcrumbs: (value: SetStateAction<Breadcrumb[]>) => void;
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextType>({
  breadcrumbs: [],
  setBreadcrumbs: () => [],
});
